import React from "react"

export default function Offers() {
  const myRef = React.useRef(null)
  const offsetY = myRef.current?.getBoundingClientRect().y

  const [inView, setInView] = React.useState(() => {
    return false
  })
  React.useEffect(() => {
    if (inView === false) {
      if (offsetY < 350) {
        setInView(true)
      }
    }
  }, [offsetY])

  return (
    <>
      <div
        className="consult-section relative"
        style={{
          backgroundImage: `url(/images/site/business.jpg)`, minHeight: "405px"
        }}
      >
        <div className="push70"/>
        <div className="container relative">
          <div className="text-center white">
            <div className="title-h1 white bold">
              Мы поможем в развитии вашей организации
            </div>
            <div className="subtitle-h1">
              Вы сможете получить консультационные услуги по сферам:
              бухгалтерского и налогового учетов, государственные закупки,
              юридические услуги.
              <br />
              Кроме того, мы оказываем комплексные услуги в области
              автоматизации бизнес-процессов, информационных технологии: аудит
              ит-инфраструктуры, разработка стратегии, планов развития ит,
              разработка программного обеспечения.
              <br />
            </div>
            <div className="push10"/>
            <a href="https://qfin.kz/contacts" className="btn white-btn min fancyboxmodal">
              <i className="material-icons">settings_phone</i>
              получить бесплатную консультацию
            </a>
          </div>
        </div>

        <div className="push70"/>
      </div>

      <div ref={myRef} className="hit-section" style={{ minHeight: "540px"}}>
        <div className="push70"/>

        <div className={"container text-center hidden " + (inView ? "visible animated fadeIn" : "")}>
          <div className="suptitle-h1">делайте бизнес</div>

          <div className="title-h1 bold">Рутиной займемся мы</div>

          <div className="subtitle-h1">
            Задача организации, в особенности же реализация намеченных плановых
            заданий требуют от нас анализа.
            <br />
            Повседневная практика показывает, что консультация с широким активом
            позволяет выполнять важные задания.
          </div>
          <div className="push10"/>

          <div className="row">
            <div className="col-sm-6 col-md-3">
              <div className={"element hidden " + (inView ? "visible animated fadeInUp" : "")}>
                <div className="img-wrapper">
                  <img
                    src="/images/features/features2-1.png"
                    alt=""
                    width="100"
                  />
                </div>
                <div className="push15"/>
                <div className="title f14 black">
                  <div className="table">
                    <div className="table-cell">Персональный бухгалтер</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-md-3">
              <div className={"element hidden " + (inView ? "visible animated fadeInUp" : "")}>
                <div className="img-wrapper">
                  <img
                    src="/images/features/features2-2.png"
                    alt=""
                    width="100"
                  />
                </div>
                <div className="push15"/>
                <div className="title f14 black">
                  <div className="table">
                    <div className="table-cell">
                      Бухгалтерское сопровождение
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-md-3">
              <div className={"element hidden " + (inView ? "visible animated fadeInUp" : "")}>
                <div className="img-wrapper">
                  <img
                    src="/images/features/features2-3.png"
                    alt=""
                    width="100"
                  />
                </div>
                <div className="push15"/>
                <div className="title f14 black">
                  <div className="table">
                    <div className="table-cell">Сдача нулевой отчетности</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-md-3">
              <div className={"element hidden " + (inView ? "visible animated fadeInUp" : "")}>
                <div className="img-wrapper">
                  <img
                    src="/images/features/features2-4.png"
                    alt=""
                    width="100"
                  />
                </div>
                <div className="push15"/>
                <div className="title f14 black">
                  <div className="table">
                    <div className="table-cell">Комплексное обслуживание</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="push60"/>
      </div>
    </>
  )
}
